module.exports = __webpack_public_path__ + "img/mask3.d07314a7.jpeg";